export default __webpack_public_path__ + "locales/vi/Payments.json?hash=2d99f6c365c23810c1066462b22be864";